/* ============================================================
   Sleep2Care — cookiebanneret skal besvares, før siden kan bruges
   ------------------------------------------------------------
   Shopifys cookiebanner (#shopify-pc__banner) vises kun for
   besøgende i regioner, der kræver samtykke, og kun indtil de
   har valgt. Mens det er synligt:
     • dæmpes siden bag banneret, og klik på den blokeres
     • siden kan ikke scrolles
     • alt bag banneret gøres "inert", så man heller ikke kan
       tabbe sig forbi med tastaturet
   Så snart den besøgende har klikket Acceptér, Afvis eller gemt
   sine valg, fjerner Shopify banneret, og låsen slippes.

   Afvis er fortsat lige så nemt som Acceptér. Det er et krav:
   man må godt kræve et valg, men ikke kræve et ja.
   ============================================================ */
(function () {
  'use strict';

  var LOCK_CLASS = 's2c-consent-locked';
  var SCRIM_ID = 's2c-consent-scrim';
  // Elementer, der skal forblive brugbare, mens låsen er aktiv
  var KEEP_IDS = { 'shopify-pc__banner': 1, 'shopify-pc__prefs': 1 };
  KEEP_IDS[SCRIM_ID] = 1;

  var locked = false;
  var inerted = [];
  var HELD_ATTR = 'data-s2c-held';

  // Spoks' nyhedsbrevs-pop-up ligger i en shadow-DOM under et af <body>'s børn.
  // Den skal vente, til cookievalget er truffet, så de to vinduer ikke stables.
  var SPOKS_HOST = 'spoks-forms-external-popup-host';
  function hasSpoks(el) {
    if (el.id === SPOKS_HOST) return true;
    var queue = [el], depth = 0;
    while (queue.length && depth < 3) {
      var next = [];
      for (var i = 0; i < queue.length; i++) {
        var n = queue[i];
        if (n.shadowRoot && n.shadowRoot.getElementById && n.shadowRoot.getElementById(SPOKS_HOST)) return true;
        for (var j = 0; j < n.children.length; j++) next.push(n.children[j]);
      }
      queue = next; depth++;
    }
    return false;
  }
  function holdPopups() {
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (/^(MAIN|HEADER|FOOTER|SCRIPT|STYLE|SECTION)$/.test(el.tagName)) return;
      if (!el.hasAttribute(HELD_ATTR) && hasSpoks(el)) el.setAttribute(HELD_ATTR, '');
    });
  }
  function releasePopups() {
    Array.prototype.forEach.call(document.querySelectorAll('[' + HELD_ATTR + ']'), function (el) {
      el.removeAttribute(HELD_ATTR);
    });
  }

  function banner() {
    return document.getElementById('shopify-pc__banner');
  }

  // Kun det, man faktisk kan se, tæller. aria-hidden ignoreres bevidst:
  // andre scripts (fx Spoks' nyhedsbrevs-pop-up) sætter det på banneret,
  // selvom banneret stadig står på skærmen.
  function bannerVisible() {
    var b = banner();
    if (!b || !b.isConnected) return false;
    var cs = window.getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getClientRects().length > 0;
  }

  // Mens låsen er aktiv, skal banneret være et rigtigt modalt vindue for
  // skærmlæsere — og ingen andre scripts må skjule det.
  function keepBannerAccessible() {
    var b = banner();
    if (!b) return;
    if (b.getAttribute('aria-hidden') === 'true') b.removeAttribute('aria-hidden');
    if (b.getAttribute('aria-modal') !== 'true') b.setAttribute('aria-modal', 'true');
  }

  function lock() {
    if (locked) return;
    locked = true;

    document.documentElement.classList.add(LOCK_CLASS);

    var scrim = document.createElement('div');
    scrim.id = SCRIM_ID;
    scrim.setAttribute('aria-hidden', 'true');
    // Klik på den dæmpede baggrund gør ingenting, og siden bagved kan ikke nås
    ['click', 'mousedown', 'touchstart', 'wheel', 'touchmove'].forEach(function (evt) {
      scrim.addEventListener(evt, function (e) { e.preventDefault(); e.stopPropagation(); }, { passive: false });
    });
    document.body.appendChild(scrim);

    // Gør alt andet på siden utilgængeligt for mus, touch og tastatur
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (KEEP_IDS[el.id]) return;
      if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName)) return;
      if (el.hasAttribute('inert')) return;
      el.setAttribute('inert', '');
      inerted.push(el);
    });

    // Flyt fokus ind i banneret, så tastatur- og skærmlæserbrugere starter dér
    var first = banner() && banner().querySelector('button, a[href]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }

  function unlock() {
    if (!locked) return;
    locked = false;

    document.documentElement.classList.remove(LOCK_CLASS);
    releasePopups();
    var scrim = document.getElementById(SCRIM_ID);
    if (scrim) scrim.remove();
    inerted.forEach(function (el) { el.removeAttribute('inert'); });
    inerted = [];
  }

  function sync() {
    if (bannerVisible()) { lock(); keepBannerAccessible(); holdPopups(); } else { unlock(); }
  }

  // Nye elementer, som apps og temaet tilføjer, mens låsen er aktiv, skal også være inerte
  function inertNewChildren(mutations) {
    if (!locked) return;
    mutations.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (el) {
        if (el.nodeType !== 1 || KEEP_IDS[el.id]) return;
        if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName)) return;
        if (!el.hasAttribute('inert')) { el.setAttribute('inert', ''); inerted.push(el); }
      });
    });
  }

  function start() {
    sync();
    var obs = new MutationObserver(function (mutations) {
      inertNewChildren(mutations);
      sync();
    });
    // Shopify indsætter og fjerner banneret som barn af <body>
    obs.observe(document.body, { childList: true });
    // ...og skjuler det nogle gange med style/class i stedet for at fjerne det
    var attrObs = new MutationObserver(sync);
    var watched = null;
    setInterval(function () {
      var b = banner();
      if (b && b !== watched) {
        watched = b;
        attrObs.disconnect();
        attrObs.observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'aria-modal'] });
      }
      sync();
    }, 500);

    // Shopify udsender denne hændelse, når den besøgende har truffet sit valg
    document.addEventListener('visitorConsentCollected', function () { setTimeout(sync, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
